import React from 'react';
import { Title } from './TitleHero.styled';

const TitleHero = () => {
  return (
    <Title>renewable energy for any task</Title>
  )
}

export default TitleHero